module.exports = __webpack_public_path__ + "static/media/iconpartypay.668118cc.svg";